import React from 'react'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import LuxuryPlusPriceStack from 'loyalty/components/LuxuryPlusPriceStack'
import { useOfferPriceWithMember } from 'hooks/Offers/useOfferPrice'

interface Props {
  captionText: string;
  memberPrice: number;
  price: number;
  value: number;
  duration: number;
  offer: App.BedbankOffer | App.Offer | App.OfferSummary
  showValueDiscount: boolean;
  discount?: number;
  taxesAndFees?: number | 'inclusive' | 'exclusive';
  saleUnit?: string;
}

function BaseOfferPriceContent({ captionText, memberPrice, price, value, duration, saleUnit, taxesAndFees, showValueDiscount, discount, offer }: Props) {
  const {
    saleUnit: displaySaleUnit,
    taxesAndFees: displayTaxesAndFees,
    total: displayPrice,
    memberTotal: displayMemberPrice,
    value: displayValue,
  } = useOfferPriceWithMember({
    value,
    saleUnit: saleUnit ?? 'total',
    duration,
    total: price,
    memberTotal: memberPrice,
    taxesAndFees: typeof taxesAndFees === 'number' ? taxesAndFees : undefined,
  })
  return (
    <>
      <PriceRowPriceCaption>{captionText}</PriceRowPriceCaption>
      <LuxuryPlusPriceStack
        price={displayPrice}
        memberPrice={displayMemberPrice}
        size="S"
        saleUnit={displaySaleUnit}
        taxesAndFees={displayTaxesAndFees ?? taxesAndFees ?? 'exclusive'}
        loyaltyConfig={offer.loyalty}
      />
      {showValueDiscount && <PriceRowValueDiscountWithCaption
        size="M"
        value={displayValue}
        discountPercentage={discount}
      />}
    </>
  )
}

export default BaseOfferPriceContent
